import type { NextPage } from 'next';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Element } from 'react-scroll';

const Services: NextPage = () => {
  const { t } = useTranslation();

  const list = t('services:data', { returnObjects: true });

  const calculateScrollDuration = useCallback(
    (distance: number) =>
      Math.abs(distance) * (0.95 + 100 / Math.abs(distance)) * 1.1,
    []
  );

  return (
    <main className="container">
      <div className="sitebar-left">
        <div className="page-title services">
          <h2>{t('navigation:services')}</h2>
        </div>
      </div>
      <div className="container-content our-services about-us">
        <div className="row">
          <div className="content">
            {list.map((item) => (
              <Element key={item.header} className="article" name={item.header}>
                <h3>{item.header}</h3>
                <p>{item.text}</p>
              </Element>
            ))}
          </div>
        </div>
        <div className="sitebar-right">
          <div className="services-menu">
            {list.map((item) => (
              <Link
                key={item.header}
                to={item.header}
                spy
                smooth
                activeClass="active-link"
                offset={-200}
                duration={calculateScrollDuration}
              >
                {item.header}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};

export default Services;
